import { render } from "./BlogDetailsLeftSidebar.vue?vue&type=template&id=7dc135f6"
import script from "./BlogDetailsLeftSidebar.vue?vue&type=script&lang=js"
export * from "./BlogDetailsLeftSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__